import { ErrorInfo, ReactNode, Component } from 'react';
import { Button }                          from '@mui/material';
import { ErrorBoundaryWrapper }            from '@styles/Shared/StyledErrorBoundary';

type TState = {
  hasError: boolean;
};

export class ErrorBoundary extends Component<{ children?: ReactNode }> {
  state: TState;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error: Error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // You can also log the error to an error reporting service
    console.log(error, errorInfo);
    this.setState({
      hasError: true,
    });
  }

  onReload() {
    window.location.reload();
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorBoundaryWrapper>
          Something went wrong...
          <Button variant="outlined" onClick={this.onReload}>
            Reload Page
          </Button>
        </ErrorBoundaryWrapper>
      );
    }

    return this.props.children;
  }
}
